export default "__VITE_ASSET__CHAjjyE6__"